import {net} from "./index";
import md5 from 'md5'

// 用户登录的方法
export const adminLogin = ({ account, password }) => {
  // 设置参数
  let params = new URLSearchParams()
  params.append('act', account)
  params.append('pswd', md5(password))
  return net.request({
    params: {},
    data: params,
    method: 'post',
    url: '/admin/verify/login',
  })
}

// 获取管理员操作日志的方法
export const getAdminLogs = ({ pageIndex = 0, pageSize = 0 }) => {
  // 设置参数
  let params = new URLSearchParams();
	params.append('page_index', pageIndex);
	params.append('page_size', pageSize);
  return net.request({
    params: {},
    data: params,
    method: 'post',
    url: '/admin/verify/getAdminLogs',
  })
}

// 更改账号密码的方法
export const updatePassword = ({ password, newPass }) => {
  // 设置参数
  let params = new URLSearchParams();
  params.append('password', md5(password));
  params.append('new_pass', md5(newPass))
  return net.request({
    data: params,
    params: {},
    method: 'post',
    url: '/admin/verify/update/password',
  })
}
